// src/components/course/ReviewImage.js
import React from "react";
import { Plus, Image as ImageIcon } from "lucide-react"; // 아이콘 활용

function ReviewImage({ imageUrl, onClickUpload }) {
  return (
    <button
      type="button"
      onClick={onClickUpload}
      className={`
        w-24 h-24 rounded-2xl flex items-center justify-center overflow-hidden transition-all
        ${
          imageUrl
            ? "border border-gray-100 shadow-sm"
            : "border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100 hover:border-gray-400"
        }
      `}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="후기 이미지"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="flex flex-col items-center gap-1 text-gray-400">
          <Plus className="w-6 h-6" />
          <span className="text-[10px] font-bold">사진 추가</span>
        </div>
      )}
    </button>
  );
}

export default ReviewImage;
